'use client';
import { ACTIVITY_ID_COOKIE_KEY } from '@eos/b4b-shared-utility/activityId';
import { createAxiosConfig } from '@eos/b4b-shared-utility/createAxiosConfig';
import { isServer } from '@eos/b4b-shared-utility/is-server';
import { AxiosConfigContext } from '@eos/shared-data-context-utility/AxiosConfigContext';
import { createClientSideQueryClient } from '@eos/shared-data-context-utility/create-query-client/createClientSideQueryClient';
import { defaultLocale } from '@eos/shared-locale-utility/locale';
import { QueryClientProvider } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { FC, PropsWithChildren, useState } from 'react';

export const QueryProvider: FC<PropsWithChildren> = ({ children }) => {
  // Use default locale since we're skipping i18n for now
  const locale = defaultLocale;
  const [queryClient] = useState(createClientSideQueryClient({ locale }));

  const searchParams = useSearchParams();
  const guestCountryCode = searchParams?.get('guestCountryCode');

  const config = createAxiosConfig({
    locale,
    activityId: (!isServer() && Cookies.get(ACTIVITY_ID_COOKIE_KEY)) || '',
    ...(guestCountryCode && { guestCountryCode }),
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AxiosConfigContext.Provider value={config}>
        {children}
      </AxiosConfigContext.Provider>
    </QueryClientProvider>
  );
};
